'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _events = require('ifeis-isomorphic/lib/redux/actions/events');

var _updateScoresheet = require('ifeis-isomorphic/lib/redux/actions/scoresheet/updateScoresheet');

var _updateScoresheet2 = _interopRequireDefault(_updateScoresheet);

var _adjudicators = require('ifeis-isomorphic/lib/redux/actions/adjudicators');

var _paths = require('ifeis-isomorphic/lib/redux/actions/feiseanna/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/adjudicators/paths');

var _events2 = require('ifeis-isomorphic/lib/utilities/events');

var _events3 = require('../../../../../events');

var _events4 = _interopRequireDefault(_events3);

var _adjudicators2 = require('../../../../../adjudicators');

var _adjudicators3 = _interopRequireDefault(_adjudicators2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventPipeline = function () {
  function EventPipeline(fid, $http, $state, $mdDialog, $q, $ngRedux, fAlert) {
    _classCallCheck(this, EventPipeline);

    _initialiseProps.call(this);

    this.svc = { fid: fid, $http: $http, $state: $state, $mdDialog: $mdDialog, $q: $q, $ngRedux: $ngRedux, fAlert: fAlert };

    // pull the adjudicators for this event
    this.svc.$ngRedux.connect(function (state) {
      if ((0, _paths.feisAdjudicatorsAreLoading)(state, fid)) {
        return { adjudicators: (0, _immutable.List)() };
      }
      return {
        adjudicators: (0, _paths2.adjudicatorsForFeis)(state, fid)
      };
    })(this);
  }

  // navigates to the scoresheet for the given event and adjudicator


  _createClass(EventPipeline, [{
    key: 'openScoresheet',
    value: function openScoresheet(e, a) {
      this.svc.$state.go('feiseanna.one.scoresheet', { event: e.id, adjudicator: a.id });
    }

    // if there are not enough scoresheets yet, opens the adjudicator picker to add a new scoresheet
    // otherwise, opens a warning dialog gating the adjudicator picker
    // dialogs are opened at the location of $event if it exists

  }, {
    key: 'addScoresheet',
    value: function addScoresheet($event, event) {
      var _this2 = this;

      var expected = (0, _events2.getExpectedScoresheets)(event.type);
      var myAdjudicators = this.adjudicators;

      var adjudicatorModal = {
        controller: ['$mdDialog', 'event', function ($mdDialog, event) {
          var _this = this;

          this.adjudicators = myAdjudicators;
          this.hide = function (a) {
            return $mdDialog.hide(a);
          };
          this.cancel = function () {
            return $mdDialog.cancel();
          };
          this.query = function (query) {
            return _this.adjudicators.filter(function (a) {
              return event.adjudicators.every(function (e) {
                return e.id !== a.get('id');
              });
            }).filter(function (a) {
              return !query || query === null || query === '' || angular.lowercase(a.get('fname') + a.get('lname')).indexOf(query) >= 0;
            }).toJS();
          };
        }],
        controllerAs: 'dialog',
        locals: { event: event, adjudicators: this.adjudicators },
        template: require('./adjudicator-picker.tpl.html'),
        targetEvent: $event
      };

      if (event.adjudicators && event.adjudicators.length > 0) {
        var confirm = this.svc.$mdDialog.confirm().title('Are you sure?').textContent('There are already ' + event.adjudicators.length + ' scoresheet(s). Are you sure you want to add another?').cancel('Cancel').targetEvent($event).ok('Yes');
        var promise = event.adjudicators.length >= expected ? this.svc.$mdDialog.show(confirm) : this.svc.$q.when(true);
        return promise.then(function () {
          return _this2.svc.$mdDialog.show(adjudicatorModal);
        }).then(function (newAdjudicator) {
          return _this2.openScoresheet(event, newAdjudicator);
        });
      }

      this.svc.$mdDialog.show(adjudicatorModal).then(function (newAdjudicator) {
        return _this2.openScoresheet(event, newAdjudicator);
      });
    }
  }, {
    key: '_sendToQA',
    value: function _sendToQA(event, $event) {
      var _this3 = this;

      return this.svc.$ngRedux.dispatch((0, _events.sendEventToQa)(this.svc.fid, event.id, event.version_id)).catch(function (e) {
        if (e && e.errors && e.errors.status === 417) {
          var _ref = e.errors.data && e.errors.data.errors[0],
              title = _ref.title,
              detail = _ref.detail;

          _this3.svc.fAlert($event, title, detail);
        }
      });
    }

    // if there are not enough scoresheets, opens a warning dialog, if there are enough
    // or if the user clicks through the warning, sends the event to QA and then calls
    // the callback function

  }, {
    key: 'sendToQA',
    value: function sendToQA(event, $event) {
      var _this4 = this;

      var expected = (0, _events2.getExpectedScoresheets)(event.type);

      // if we have enough scoresheets, go ahead and send to QA without confirmation
      if (expected <= event.adjudicators.length) {
        return this._sendToQA(event, $event);
      }

      // otherwise, get confirmation from the user first
      var dialog = this.svc.$mdDialog.confirm().title('Are you sure?').textContent('There are ' + event.adjudicators.length + ' scoresheet(s) instead of ' + expected + '. Are you sure data entry is done?').cancel('Cancel').ok('Yes');

      return this.svc.$mdDialog.show(dialog).then(function () {
        return _this4._sendToQA(event, $event);
      });
    }
  }]);

  return EventPipeline;
}();

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.completeScoresheet = function (fid, eventId, adjId, eventVersionId) {
    return _this5.svc.$ngRedux.dispatch((0, _updateScoresheet2.default)(fid, eventId, adjId, eventVersionId));
  };
};

exports.default = angular.module('ifeis.eventPipeline', ['ifeis.events', 'ifeis.adjudicators']).factory('fEventPipelineService', function ($http, $state, $mdDialog, $q, $ngRedux) {
  return function (fid) {
    return new EventPipeline(fid, $http, $state, $mdDialog, $q, $ngRedux);
  };
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/tabulations/eventPipeline.js
// module id = 220
// module chunks = 0